import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class BasePriorityProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'priority/base'

  update(_: string | number, item: object) {
    return this.submit('put', `/${this.endpoint}`, item)
  }
}
